import {
    SetupTitle,
    Title,
    SetupText,
    CurrencySymbol,
    PriceRow,
    PriceTerm,
    PriceWrapper,
    MoneyGroup,
    DarkSection,
    WrapperButton,
} from "./Price.styles";

import Button from "../Button";

interface PriceTagProps {
    value: string;
}

export function PriceTag({ value }: PriceTagProps) {
    const numericValue = parseFloat(value.replace(",", "."));
    const setupFeeValue = 400 + numericValue;
    const formattedSetupFee = setupFeeValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return (
        <DarkSection>
            <PriceWrapper>
                <PriceRow>
                    <CurrencySymbol $mt={8}>R$</CurrencySymbol>
                    <Title>{value}</Title>
                    <PriceTerm>mensal</PriceTerm>
                </PriceRow>

                <SetupText>
                    <SetupTitle>Setup Inicial</SetupTitle>
                    <MoneyGroup>
                        <CurrencySymbol $size={14} $mt={4}>R$</CurrencySymbol>
                        <Title $size={24} $ml={2}>{formattedSetupFee}</Title>
                    </MoneyGroup>
                </SetupText>
            </PriceWrapper>

            <WrapperButton>
                <Button style={{color: "#000"}}>ASSINAR</Button>
            </WrapperButton>
        </DarkSection>
    );
}
